import * as React from "react";

import { Root } from "./UnitCaption.styles";

interface UnitCaptionProps {
    className?: string;
    children: React.ReactNode;
}

export function UnitCaption(props: UnitCaptionProps): JSX.Element {
    return <Root className={props.className}>{props.children}</Root>;
}
